/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames/bind'
import * as styles from './Button.scss'

const cx = classNames.bind(styles)

interface IProps {
  children?: any,
  styleType?: string,
  buttonType?: string,
  disabled?: boolean,
  onClick?: (val: any) => any,
  round?: boolean,
  size?: string,
  fluid?: boolean,
  type?: string,
  isExternalLink: boolean,
}

const Button: React.SFC<IProps> = ({
  children,
  styleType = 'primary',
  size = 'medium',
  fluid,
  type = 'button',
  disabled,
  isExternalLink,
  buttonType,
  ...restProps
}) => {
  let Component = 'button'
  if (type === 'link') {
    Component = isExternalLink ? 'a' : Link
  }
  return (
    <Component
      {...restProps}
      disabled={disabled}
      className={cx(
        'root',
        styleType,
        size,
        {
          fluid,
          disabled,
        },
      )}
      type={buttonType}
      title={typeof children === 'string' ? children : undefined}
    >
      {children}
    </Component>
  )
}

export default Button
